import { zh as views_zh } from "./views";

const zh = {
  "app.global.spanish": "西班牙语",
  "app.global.english": "英语",

  "login.welcome": "欢迎！",
  "login.start_session": "开始会话",
  "login.invalid_user_password": "用户名或密码无效！",
  "login.button_enter": "进入",
  "login.password": "密码",
  "login.database": "数据库",
  "login.username": "用户名",
  "login.forgot_password": "忘记密码？",

  "board.loading_please_wait": "加载中… 请稍候！",
  "board.loading": "加载中…",
  "board.approve": "批准",
  "board.button_edit": "编辑",
  button_edit: "编辑",
  "board.button_add": "添加",
  button_add: "添加",
  "board.button_back": "返回",
  "board.button_save": "保存",
  "board.button_remove": "删除",
  "board.button_replace": "替换",
  "board.filter": "筛选",
  "board.button_confirm": "确认",
  "board.chart.in_thousands": "以千为单位",
  "board.chart.see_report": "查看报表",
  "board.sheet_select": "工作表",
  "board.missing_required_fields": "缺少必填字段！",

  "quicktable.select_all": "全部",
  missing_required_fields: "缺少必填字段！",

  "board.records_found": "找到的记录",
  "board.records_saved": "记录已保存！",
  "board.record_created": "记录已创建！",

  "board.dialog.button_discard": "忽略",

  "basic_modal.button_cancel": "取消",
  "basic_modal.button_ok": "确定",
  "basic_modal.button_accept": "接受",
  "basic_modal.button_close": "关闭",
  "basic_modal.button_create": "创建",

  available: "可用",
  not_available: "不可用",
  select_time: "请选择时间…",

  "form_cloud_image.add_photo": "添加图片",

  "menu.dashboard": "仪表盘",
  "menu.dashboard_melhous": "MELHOUS",
  "menu.delivery": "配送",
  "menu.order": "订单",
  "menu.sale_order": "销售订单",
  "menu.housekeeping": "客房清洁",
  "menu.rest_order": "餐厅订单",
  "menu.travel_person": "旅客",
  "menu.ticket": "排号管理",
  "menu.affiliates": "合作伙伴",
  "menu.assistant_control": "访问控制",
  "menu.sale_call_center": "订单登记",

  "sale.sale.number": "编号",
  "sale.sale.sale_date": "日期",
  "sale.sale.consumer": "客户",
  "sale.sale.position": "位置",
  "sale.sale.channel": "渠道",
  "sale.sale.delivery_state": "状态",
  "sale.sale.comment": "备注",
  "sale.sale.party": "客户",
  "sale.sale.waiting_time": "等待时间",
  "sale.sale.order_status": "订单状态",
  "sale.sale.commanded": "已下单",
  "sale.sale.draft": "草稿",
  "sale.sale.billing": "计费",
  "sale.sale.invoice_number": "发票编号",
  "sale.sale.pay": "支付",
  "sale.sale.dispatched": "已发货",
  "sale.sale.rejected": "已拒绝",
  "sale.sale.delivered": "已交付",
  "sale.sale.processing": "处理中",
  "sale.sale.terminal": "终端",
  "sale.sale.gateway": "支付网关",
  "sale.sale.total_amount": "总计",
  "sale.sale.source": "来源",
  "sale.sale.description": "描述",
  "sale.sale.state": "状态",
  "sale.sale.payment_method": "支付方式",
  "sale.sale.cash": "现金",
  "sale.sale.persons": "人数",
  "sale.sale.shipping_date": "发货日期",

  "sale.line.product": "产品",
  "sale.line.quantity": "数量",
  "sale.line.discount": "折扣",
  "sale.line.unit_price": "单价",
  "sale.line.unit": "单位",
  "sale.line.unit_price_w_tax": "含税单价",
  "sale.line.sale_price_taxed": "含税价格",
  "sale.line.amount": "金额",

  "sale.sale.quote": "确认",
  "sale.sale.salesman": "销售员",
  "sale.sale.shipment_address": "收货地址",
  "sale.sale.agent": "代理",
  "sale.sale": "销售",
  "sale.line": "产品",

  button_cancel: "取消",
  successful_order: "订单成功！",
  "sale.sale.price_list": "价格表",
  button_delete: "删除",

  "sale.sale.shipment_date": "发货日期",
  "sale.sale.today": "今天",

  "menu.stock_request": "库存申请",
  "menu.inventory": "库存",
  "stock.inventory": "库存",
  "stock.inventory.line": "明细",

  "menu.purchase_requisition": "采购申请",
  "stock.shipment.internal": "内部调拨",
  "stock.shipment.internal.reference ": "参考",
  "stock.shipment.internal.from_location": "来源位置",
  "stock.shipment.internal.to_location": "目标位置",
  "stock.shipment.internal.requested_by": "申请人",
  "stock.shipment.internal.moves": "产品",
  "stock.shipment.internal.state": "状态",
  "stock.shipment.internal.number": "编号",
  "stock.shipment.internal.effective_date": "生效日期",
  "stock.shipment.internal.today": "今天",
  "stock.shipment.internal.wait": "确认",
  "stock.shipment.internal.planned_start_date": "计划发货日期",
  "stock.shipment.internal.print": "打印",

  effective_date: "计划日期",
  uom: "计量单位",
  default_uom: "计量单位",

  "stock.move": "产品",
  "stock.move.product": "产品",
  "stock.move.uom": "单位",
  "stock.move.quantity": "数量",

  waiting: "等待中",
  request: "申请",
  billing: "计费",
  print: "打印",

  user_has_not_access_permissions: "用户没有访问权限！",
  "purchase.purchase.purchase_date": "日期",
  "purchase.purchase.number": "编号",
  "purchase.purchase.approved": "已批准",
  "purchase.purchase.confirmed": "已确认",
  "purchase.purchase.done": "已完成",
  "purchase.purchase.processing": "处理中",
  "purchase.purchase.cancelled": "已取消",
  "purchase.purchase.total_amount": "总金额",
  "purchase.purchase.party": "供应商",
  "purchase.purchase.state": "状态",
  "purchase.purchase.project": "项目",
  "purchase.purchase.create_uid": "用户",
  "purchase.purchase.description": "描述",
  "purchase.purchase.payment_term": "付款条件",
  "purchase.purchase.reference": "参考",
  "purchase.purchase.untaxed_amount": "未税金额",
  "purchase.purchase.tax_amount": "税额",
  "purchase.purchase.comment": "备注",
  "purchase.purchase.today": "今天",
  "purchase.purchase": "采购",
  "purchase.purchase.pending": "待处理",
  "purchase.purchase.all": "全部",
  "purchase.purchase.quotation": "报价单",
  "purchase.purchase.draft": "草稿",
  "menu.purchase": "采购",
  "menu.purchase_approval": "采购审批",
  "menu.shipment_internal": "内部调拨",
  "purchase.line": "产品",
  "product.code": "编码",
  "product.description": "描述",
  "menu.surveillance_schedule": "监控",
  "surveillance.schedule": "监控",
  supplier: "供应商",
  code: "编码",
  employee: "员工",
  active: "启用",
  city: "城市",
  name: "名称",
  position: "职位",
  "board.button_reload": "重新加载",
  successful: "交易成功！",
  total_amount_cache: "总金额",
  untaxed_amount_cache: "小计",
  tax_amount_cache: "税额",
  high: "高",
  urgent: "紧急",
  low: "低",
  "purchase.purchase.priority": "优先级",
  "purchase.purchase.approval": "审批",
  "purchase.purchase.approval_user": "审批人",
  "purchase.purchase.approval_date": "审批日期",
  "purchase.purchase.approval_signature": "批准人",
  "purchase.purchase.authorize": "授权",
  "purchase.purchase.authorized_user": "授权用户",
  "purchase.purchase.authorized_signature": "授权人",
  "purchase.purchase.confirm": "确认",
  "purchase.purchase.confirmation_signature": "确认人",
  "purchase.purchase.confirm_user": "确认人",
  "purchase.line.product": "产品",
  "purchase.line.unit_price": "单价",
  "purchase.line.amount": "金额",
  "purchase.line.quantity": "数量",
  "purchase.line.description": "描述",
  "menu.hotel_planner": "计划器",
  "menu.hotel_calendar": "日历",
  "menu.hotel_rack": "房态表",
  "menu.take_order": "下单",
  "menu.order_viewer": "订单查看器",
  table_assigned: "桌号",
  command: "下单",
  note: "备注",
  order_sended: "已发送",
  "sale.line.note": "备注",
  "sale.line.requested": "已请求",
  "sale.line.draft": "草稿",
  "sale.line.commanded": "已下单",
  "room.none": "无",
  "room.blocked": "已锁定",
  "room.check_in": "入住",
  "room.check_out": "退房",
  "room.maintenance": "维护中",
  "room.pending": "待处理",
  "menu.self_service_sale": "自助销售",
  "app.webcheckin": "在线入住",
  "menu.web_checkin": "在线入住",
  "app.webcheckin.DIRECTO": "直达",
  "hotel.folio.guest.cedula_de_ciudadania": "公民身份证",
  "hotel.folio.guest.pasaporte": "护照",
  "hotel.folio.guest.tarjeta_de_identidad": "身份证",
  "hotel.folio.guest.tarjeta_de_extranjeria": "外国人身份证",
  "hotel.folio.guest.cedula_de_extranjeria": "外国人居留证",
  "hotel.folio.guest.male": "男",
  "hotel.folio.guest.female": "女",
  "hotel.maintenance": "维护",
  "hotel.maintenance.start_date": "开始日期",
  "hotel.maintenance.end_date": "结束日期",
  "hotel.maintenance.room": "房间",
  "hotel.maintenance.criticality": "紧急程度",
  "hotel.maintenance.issue": "问题",
  "hotel.maintenance.confirm": "确认",
  "hotel.maintenance.low": "低",
  "hotel.maintenance.urgent": "紧急",
  "hotel.maintenance.important": "重要",
  "hotel.maintenance.total_days": "总天数",
  finish: "完成",
  webcheckin_success_msg:
    "恭喜您，您的入住手续将更加快捷，从现在开始您可以享受我们的高级服务。",
  webcheckin_success_header: "注册成功！",
  webcheckin_success_our_services: "我们的服务",
  webcheckin_booking_page:
    "现在您可以为每个已预订的房间添加住客，每次点击房间即可添加人员。",
  male: "男",
  female: "女",
  cedula_ciudadania: "公民身份证",
  pasaporte: "护照",
  tarjeta_identidad: "身份证",
  tarjeta_extranjeria: "外国人身份证",
  cedula_extranjeria: "外国人居留证",
  adult: "成人",
  child: "儿童",
  type: "类型",
  link: "链接",
  file: "文件",
  "menu.charts": "仪表盘",
  sales: "销售",
  payroll: "薪资",
  hotel: "酒店",
  crm: "客户关系管理",
  purchases: "采购",
  dashboard: "仪表盘",
  go_back: "返回",
  address: "地址",
  country_residence: "居住国家",
  unit: "单位",
  company: "公司",
  user: "用户",
  password: "密码",
  enter: "进入",
  "modal_msg.record_successful": "记录保存成功！",
  "modal_msg.record_warning": "警告！",
  "modal_msg.record_ask": "询问",
  "modal_msg.record_error": "记录错误",
  "crm.customer_service.addres": "地址",
  "crm.customer_service.search": "搜索",
  "crm.customer_service.case": "原因详情",
  "crm.customer_service.response": "回复",
  "crm.customer_service.description": "请求摘要",
  "crm.customer_service.state": "状态",
  "crm.customer_service.party": "姓名",
  "crm.customer_service.cs_date": "日期",
  "crm.customer_service.number": "登记编号",
  "crm.customer_service.party_id_number": "身份证号",
  "crm.customer_service.draft": "已登记",
  "crm.customer_service.open": "打开",
  "crm.customer_service.close": "关闭",
  "crm.customer_service.email": "电子邮件",
  "crm.customer_service.attach_customer_1": "附件",
  "crm.customer_service.create_service": "创建工单",
  "crm.customer_service.ethnical_group": "民族群体",
  "crm.customer_service.special_population": "特殊人群",
  "crm.customer_service.personal_information": "个人信息",
  "crm.customer_service.pqrs_information": "PQRS 信息",
  "crm.customer_service.demographic_information": "社会人口统计信息",
  "crm.customer_service.description_facts": "事实描述",
  "crm.customer_service.phone": "电话",
  "crm.customer_service.health_provider": "医疗服务提供者",
  "crm.customer_service.detailed_especific_1": "具体详情",
  "form_modal.button_close": "关闭",
  button_open: "打开",
  "board.dialog.button_close": "关闭",
  "board.dialog.button_ok": "确定",
  "board.dialog.button_cancel": "取消",
  "planner.date": "日期",
  "hotel.folio.meal_plan": "餐饮计划",
  "hotel.folio.pending_total": "待结总额",
  "hotel.folio.agent": "代理",
  "hotel.folio.unit_price_w_tax": "含税价格",
  "hotel.folio.vehicle_plate": "车牌号",
  "hotel.folio.guests": "住客",
  "hotel.folio.payment_status": "付款状态",
  "hotel.folio.charge": "费用",
  "hotel.folio.charge.description": "描述",
  "hotel.folio.charges": "费用",
  "hotel.folio.guest": "住客",
  "hotel.folio.guest.main_guest": "主要住客",
  "hotel.folio.guest.name": "姓名",
  "hotel.folio.guest.type_document": "证件类型",
  "hotel.folio.guest.id_number": "证件号码",
  "hotel.folio.guest.mobile": "手机",
  "hotel.folio.guest.email": "电子邮箱",
  "hotel.folio.guest.address": "地址",
  "hotel.folio.guest.nationality": "国籍",
  "hotel.folio.guest.origin_country": "原籍国家",
  "hotel.folio.guest.target_country": "目的地国家",
  "hotel.folio.guest.birthday": "出生日期",
  "hotel.folio.guest.notes": "备注",
  "hotel.folio.guest.visa_date": "签证日期",
  "hotel.folio.guest.visa_number": "签证号码",
  "hotel.folio.guest.sex": "性别",
  "hotel.folio.guest.profession": "职业",
  "hotel.folio.guest.registro_civil": "出生登记证明",
  "hotel.folio.guest.tarjeta_identidad": "身份证",
  "hotel.folio.guest.cedula_ciudadania": "公民身份证",
  "hotel.folio.guest.tarjeta_extranjeria": "外国人身份证",
  "hotel.folio.guest.cedula_extranjeria": "外国人居留证",
  "hotel.folio.guest.nit": "税号（NIT）",
  "hotel.folio.guest.add_guest": "添加",
  "hotel.folio.guest.cancel": "取消",
  "hotel.folio.guest.tipo_documento_extranjero": "外国证件类型",
  "hotel.folio.guest.pep": "PEP",
  "hotel.folio.guest.nit_otro_pais": "外国税号（NIT）",
  "hotel.folio.guest.nuip": "NUIP",
  "hotel.folio.guest.country": "国家",
  "hotel.folio.guest.subdivision": "行政区划",
  "hotel.folio.guest.clone_holder": "创建住客",
  "hotel.folio.charge.sale_date": "日期",
  "hotel.folio.charge.product": "产品",
  "hotel.folio.charge.quantity": "数量",
  "hotel.folio.charge.unit_price_w_tax": "含税单价",
  "hotel.folio.charge.amount": "金额",
  "hotel.folio.charge.status": "状态",
  "hotel.folio.charge.pending": "待处理",
  "hotel.folio.charge.add_product": "添加产品",
  "app.webcheckin.customer": "客户",
  "app.webcheckin.no_booking": "预订编号",
  "app.webcheckin.channel": "渠道",
  "app.webcheckin.arrival_date": "到达日期",
  "app.webcheckin.departure_date": "离店日期",
  "app.webcheckin.finish": "完成",
  "app.webcheckin.direct": "直达",
  "app.webcheckin.main_guest": "您是主要住客吗？",
  "app.webcheckin.name": "姓名",
  "app.webcheckin.mobile": "手机",
  "app.webcheckin.email": "电子邮箱",
  "app.webcheckin.address": "地址",
  "app.webcheckin.nationality": "国籍",
  "app.webcheckin.country_residence": "居住国家",
  "app.webcheckin.sex": "性别",
  "app.webcheckin.type_guest": "住客类型",
  "app.webcheckin.id_number": "证件号码",
  "app.webcheckin.type_document": "证件类型",
  "app.webcheckin.visa_number": "签证号码",
  "app.webcheckin.visa_date": "签证到期日",
  "app.webcheckin.birthday": "出生日期",
  "app.webcheckin.profession": "职业",
  "app.webcheckin.add_guest": "添加住客",
  "app.webcheckin.cancel": "取消",
  "surveillance.location.code": "编码",
  "surveillance.location.name": "名称",
  "surveillance.location.customer": "客户",
  "surveillance.location.city": "城市",
  "schedule.scheduling": "排班",
  "surveillance.schedule.shift": "班次",
  "surveillance.schedule.shift.guard": "保安",
  "surveillance.schedule.shift.location": "地点",
  "surveillance.schedule.shift.shift_date": "日期",
  "surveillance.schedule.shift.replicate": "复制",
  "surveillance.schedule.shift.extra_shift": "加班",
  "surveillance.schedule.shift.shift": "班次类型",
  "surveillance.schedule.shift.duration": "时长",
  "surveillance.schedule.shift.enter_dtime": "进入时间",
  "surveillance.schedule.shift.exit_dtime": "离开时间",
  "surveillance.schedule.shift.position": "岗位",
  "surveillance.schedule.shift.event_category": "计划事件",
  "surveillance.schedule.shift.event": "实际事件",
  "surveillance.schedule.shift.notes": "备注",
  "surveillance.schedule.shift.event_start_date": "事件开始",
  "surveillance.schedule.shift.event_end_date": "事件结束",
  "surveillance.schedule.shift.kind": "班次",
  "surveillance.schedule.shift.state": "状态",
  "surveillance.schedule.shift.guard.photo_link": "照片",
  "surveillance.schedule.shift.draft": "草稿",
  "surveillance.schedule.shift.performed": "已执行",
  "surveillance.schedule.shift.schedule": "排班",
  "surveillance.schedule.state": "状态",
  "surveillance.schedule.draft": "草稿",
  "surveillance.schedule.planned": "已计划",
  "schedule.shift": "班次",
  "schedule.search": "搜索",
  "company.employee.party": "员工",
  "company.employee.code": "编码",
  "modal.search": "搜索",
  "surveillance.schedule.period": "周期",
  "surveillance.schedule.location": "地点",
  "crm.opportunity.state": "状态",
  "crm.opportunity.agent": "代理",
  "crm.opportunity.party_contact": "联系人",
  "crm.opportunity.party_category": "类别",
  "crm.opportunity.contact_phone": "电话",
  "crm.opportunity.state.lead": "线索",
  "crm.opportunity.state.opportunity": "商机",
  "crm.opportunity.city": "城市",
  "crm.opportunity.conversion_probability": "转化概率",
  "crm.opportunity.lead_origin": "来源",
  "crm.opportunity.amount": "金额",
  "crm.opportunity.type": "类型",
  "crm.opportunity.prospect": "潜在客户",
  "crm.opportunity.end_date": "结束日期",
  "crm.opportunity.line.payment_term": "付款条件",
  "crm.opportunity.line.description": "描述",
  "crm.opportunity.line.billing_frecuency": "计费周期",
  "crm.opportunity.line.unit": "单位",
  "crm.opportunity.line.availability": "可用性",
  "crm.opportunity.brochure": "宣传册",
  "crm.opportunity.company": "公司",
  "crm.opportunity.contact_email": "联系邮箱",
  "crm.opportunity.more_probabilty": "更高概率",
  "crm.opportunity.last_90": "最近90天",
  "crm.opportunity.last_quotations": "最近报价",
  "crm.opportunity.panel.win_rate": "赢单率",
  "crm.opportunity.panel.win_rate_today": "今天",
  "crm.opportunity.panel.win_rate_yesterday": "昨天",
  "crm.opportunity.panel.activities_today": "今日活动",
  "crm.opportunity.panel.activities_tomorrow": "明日活动",
  "crm.opportunity.panel.activities_pending": "待处理活动",
  "crm.opportunity.panel.leads": "线索",
  "crm.opportunity.panel.leads_draft": "草稿",
  "crm.opportunity.panel.leads_convert": "已转化",
  "crm.opportunity.sales.sale_date": "销售日期",
  "crm.prospect.name": "姓名",
  "crm.prospect.phone": "电话",
  "crm.prospect.email": "电子邮箱",
  "crm.prospect.agent": "代理",
  "modal_form.button_accept": "接受",
  "modal_form.button_add": "添加",
  "modal_form.button_save": "保存",
  "board.button_field_create": "创建",
  "board.button_field_edit": "编辑",
  "party.party.id_number": "证件号码",
  "party.party.type_document": "证件类型",
  "party.party.nationality": "国籍",
  "party.party.main_email": "电子邮箱",
  "party.party.main_mobile": "手机",
  "party.party.phone": "电话",
  "party.party.sex": "性别",
  "party.party.birthday": "出生日期",
  "party.party": "添加客户",
  "party.party.street": "街道",
  "party.party.account_receivable": "应收账款",
  "party.party.country": "国家",
  "party.party.subdivision": "行政区划",
  "party.party.city": "城市",
  holder: "持有人",
  holder_guest: "持有人 / 住客",
  guest: "住客",
  no_breakfast: "不含早餐",
  all_inclusive: "全包",
  bed_breakfast: "住宿含早餐",
  full_american: "全美式",
  half_american: "半美式",
  "menu.activity": "活动",
  "sale_activity.activity.time_start": "开始时间",
  "sale_activity.activity.time_end": "结束时间",
  "sale_activity.activity.available": "可用",
  "sale_activity.activity.quota": "配额",
  "sale_activity.activity.state": "状态",
  "sale_activity.activity.add": "添加",
  "sale_activity.activity.employee": "员工",
  "sale.sale.add_courtesy": "添加赠送",
  all: "全部",
  partial: "部分",
  "maintenance.equipment.code": "编码",
  "maintenance.equipment.gps_link": "GPS 链接",
  "maintenance.equipment.gps_passwd": "GPS 密码",
  "maintenance.equipment.brand": "品牌",
  "maintenance.equipment.type_device": "设备类型",
  "maintenance.equipment.date_return": "归还日期",
  "maintenance.equipment.issues": "问题",
  "maintenance.equipment.status": "状态",
  "maintenance.equipment.available": "可用",
  "maintenance.equipment.maintenance": "维护中",
  "maintenance.equipment.not_available": "不可用",
  "maintenance.equipment.stolen": "被盗",
  driver_license: "驾驶证",
  passport: "护照",
  medicare_card: "医保卡",
  phone: "电话",
  fax: "传真",
  email: "电子邮箱",
  chat: "聊天",
  walking: "步行",
  web: "网页",
  channel_manager: "渠道管理",
  ota: "OTA",
  "rest_order.options": "选项",
  "surveillance.schedule_month.report.period": "周期",
  "surveillance.schedule_month.report.location": "地点",
  "surveillance.schedule_month.report": "合规报告",
  "maintenance.equipment.state": "状态",
  "maintenance.equipment.excelñent": "优秀",
  "maintenance.equipment.good": "良好",
  "maintenance.equipment.acceptable": "可接受",
  "maintenance.equipment.bad": "差",
  "maintenance.equipment.product": "产品",
  "maintenance.equipment.active": "启用",
  "maintenance.equipment.gps_serial": "GPS 序列号",
  "maintenance.equipment.serial": "序列号",
  "maintenance.equipment.vin": "车架号",
  "maintenance.equipment.model_num": "型号",
  "maintenance.equipment": "设备与仪器",
  "menu.maintenance": "设备与仪器",
  "menu.rentalb": "预订",
  monthly: "每月",
  one_payment: "一次性付款",
  bimonthly: "双月",
  biannual: "半年",
  annual: "年度",
  "crm.customer_service": "提交表单",
  "sale.sale.confirmed": "已确认",
  "sale.sale.party.mobile": "手机",
  "sale.sale.party.name": "客户",
  "party.addresses": "地址",
  "party.addresses.street": "街道",
  "party.addresses.country_code": "国家",
  "party.addresses.department_code": "省/州",
  "party.addresses.city_code": "城市",
  "party.contact_mechanisms": "联系方式",
  "party.contact_mechanisms.type": "类型",
  "party.contact_mechanisms.name": "名称",
  "party.contact_mechanisms.value": "联系方式",
  "sale.sale.party.id_number": "证件号",
  "date_range.select": "选择",
  "date_range.filter_date": "筛选日期",
  "sale.sale.reference": "参考",
  "sale.sale.month": "月份",
  "sale.sale.month_3": "3个月",
  "sale.sale.month_6": "6个月",
  "sale.sale.printBrowser": "打印",
  agent: "代理",
  news: "新闻",
  leads: "线索",
  opportunity: "商机",
  won: "赢单",
  lost: "丢单",
  cancelled: "已取消",
  amount: "金额",
  success_rate: "成功率",
  product: "产品",
  accomodation: "住宿",
  "crm.person": "陪同人员",
  "crm.person.name": "姓名",
  "crm.person.id_number": "证件号",
  "crm.person.phone": "电话",
  "crm.person.email": "电子邮箱",
  "sale.line.person": "陪同人员",
  "sale.line.person.name": "姓名",
  "sale.line.person.id_number": "证件号",
  "sale.line.person.phone": "电话",
  "sale.line.person.email": "电子邮箱",
  "sale.line.person.arrival_date": "到达日期",
  "sale.line.person.today": "今天",
  "sale.line.person.month": "月",
  "sale.line.person.week": "周",
  "sale.line.person.line": "服务",
  "sale.line.person.sale": "销售",
  "web.booking.avalaible": "可用",
  "web.booking.occupation": "入住情况",
  "web.booking.minimum_stay": "最少入住",
  "app.booking.name": "名",
  "app.booking.lastname": "姓",
  "app.booking.add_pay": "添加付款",
  "app.booking.sex": "性别",
  "app.booking.type_document": "证件类型",
  "app.booking.id_number": "证件号",
  "app.booking.mobile": "电话",
  "app.booking.email": "电子邮箱",
  "app.booking.address": "地址",
  "app.booking.btn-form": "预订",
  "app.booking.btn-form-payment": "结账",
  "app.booking.country": "国家",
  "app.booking.department": "省/州",
  "app.booking.city": "城市",
  "app.booking.msg_nodata": "暂无可用房间",
  "app.booking.msg_minimum_stay": "所选日期至少需要入住 {nights} 晚。",
  "app.booking.msg_nodate": "请选择入住和退房日期",
  "app.booking.note": "备注",
  "menu.account_statement": "对账单",
  "web.booking.txt_iva": "已包含费用和税费",
  "app.booking.term_cond": "条款与条件",
  "app.booking.privacy": "隐私政策",
  "sale_pos.money_count.bill": "面额",
  "sale_pos.money_count.quantity": "数量",
  "sale_pos.money_count.amount": "金额",
  "sale_pos.money_count.total": "合计",
  "app.booking.redirect": "正在跳转至支付...",
  "app.booking.label_form": "添加预订人信息",
  "app.booking.label_aside": "您的预订",
  "app.booking.btn_confirm": "确认",
  "app.booking.amount": "总计：",
  "app.booking.right_reserved": "保留所有权利",
  "app.booking.copyright": "Presik 版权所有 © 2025",
  "app.booking.validate_email": "请验证您的邮箱",
  "app.booking.create_reserve": "预订已创建",
  "app.booking.successfully": "成功",
  "app.booking.alert_filter_date": "请选择退房日期早于入住日期。",
  "app.booking.alert_select_room": "请选择房型进行预订。",
  "app.booking.date_payment": "付款日期",
  "app.booking.night": "晚",
  "app.booking.price": "价格",
  "app.booking.includes": "包含",
  "app.booking.btn_reserve_item": "添加预订",
  "app.booking.btn_add_coupon": "添加优惠券",
  "app.booking.note_placeholder": "尊敬的客人，请写下您的特殊需求。",
  "sale_pos.money_count": "现金盘点",
  "ticket_system.ticket.status": "状态",
  "ticket_system.ticket.waiting": "等待中",
  "ticket_system.ticket.done": "完成",
  "ticket_system.ticket.busy": "忙碌",
  "ticket_system.ticket.cancelled": "已取消",
  "ticket_system.ticket.turn": "排号",
  "ticket_system.ticket.number_id": "证件号",
  "ticket_system.ticket.position.number": "位置",
  "ticket_system.ticket.state": "状态",
  "ticket_system.ticke_not_found": "没有等待中的班次",
  "ticket_system.ticket.add_turn": "您必须先领取一个号",
  "ticket_system.ticket.next_turn": "下一位",
  "ticket_system.ticket.take_turn": "取号",
  "ticket_system.ticket.finish_turn": "结束班次",
  "ticket_system.ticket.currents_turn": "收银班次",
  "ticket_system.ticket.attention_schedule": "服务时间",
  "ticket_system.ticket.weekday": "周一至周五",
  "ticket_system.ticket.wekend": "周六至周日",
  "hotel.calendar.add_booking": "预订",
  "hotel.calendar.add_maintenance": "维护",
  "hotel.guest.you_can_not_clone_holder": "在创建负责人之前，无法自动创建住客",
  "account_statement_co.advanced_report": "高级对账单报告",
  "account_statement_co.advanced": "高级对账单报告",
  "account_statement_co.advanced.description": "包含所有门店/环境的对账单",
  "account_statement_co.advanced.start.operation_center": "运营中心",
  "account_statement_co.advanced.start.date": "日期",
  "account_statement_co.cash_up_report": "现金结算报告",
  "account_statement_co.cash_up": "现金结算报告",
  "account_statement_co.cash_up.description": "个人现金结算报告",
  "account_statement_co.cash_up.start.operation_center": "日期",
  "account_statement_co.cash_up.start.date": "日期",
  "account_statement_co.cash_up.start.shop": "门店",
  "account_statement_co.cash_up.start.user": "用户",
  "hotel.folio.guest.adult": "成人",
  "hotel.folio.guest.child": "儿童",
  "booking.widget.screen.view_more": "查看更多",
  add_header_modal: "添加",
  "booking.widget.screen.view_less": "收起",
  "hotel.folio.guest.transfer": "交通",
  "hotel.folio.guest.notes_transfer": "交通备注",
  "hotel.folio.guest.cradle": "婴儿床",
  "hotel.folio.guest.notes_cradle": "婴儿床备注",
  "hotel.folio.guest.pet": "宠物",
  "hotel.folio.guest.notes_pet": "宠物备注",
};

const _zh = { ...zh, ...views_zh };
export default _zh;
